import React, { ReactNode } from 'react'

import moment, { Moment } from 'moment'

import { PlanPeriodDto } from 'core/application/adminDashboard/benefitDetails/benefitPlanPeriods'
import { BenefitDesignStatus } from 'core/domain/benefit/benefitDesignStatus'

import Input from 'common/components/dataEntry/components/Input'
import Option from 'common/components/dataEntry/components/Option'
import Select from 'common/components/dataEntry/components/Select'

import { parseZoneFormat } from 'common/dateFormatters'

import './PlanYearSelectorStyles.less'

export interface NewPlanYearSelectorProps {
  planPeriods: PlanPeriodDto[]
  selected?: string
  setActivePlanPeriod: (planPeriod: string) => void
}

export const NewPlanYearSelector: React.FC<NewPlanYearSelectorProps> = ({
  planPeriods,
  selected,
  setActivePlanPeriod,
}) => {
  return planPeriods.length == 1 ? (
    <>
      <div className="plan_period_selector">
        <h6 className="plan_year_label pr-8">Plan Year:</h6>
        <Input
          defaultValue={getPlanPeriodFormated(planPeriods[0].startDate, planPeriods[0].endDate)}
          disabled
          className="plan_year_interval"
        />
      </div>
    </>
  ) : (
    <>
      <div className="plan_period_selector">
        <Select
          className="plan_year_interval"
          size="middle"
          onChange={(value) => {
            setActivePlanPeriod(value)
          }}
          value={[selected || '']}
        >
          {planPeriods?.reverse().map((planPeriod: PlanPeriodDto) => (
            <Option
              key={planPeriod.id}
              value={planPeriod.id}
              disabled={planPeriod.benefitDesignStatus == BenefitDesignStatus.NotStarted}
            >
              {getPlanPeriodFormated(planPeriod.startDate, planPeriod.endDate)}
            </Option>
          ))}
        </Select>
      </div>
    </>
  )
}

const getPlanPeriodFormated = (startDate: string | Moment, endDate: string | Moment): string => {
  return `${parseZoneFormat(startDate)} - ${parseZoneFormat(endDate)}`
}
